import { appInitialState } from './reducers/app';
import { userInitialState } from './reducers/user';

export const initialState = {
  app: appInitialState,
  user: userInitialState,
};

export type State = typeof initialState;
